import { render, staticRenderFns } from "./QaListItemPresenter.vue?vue&type=template&id=ed42cffe&scoped=true&"
import script from "./QaListItemPresenter.vue?vue&type=script&lang=js&"
export * from "./QaListItemPresenter.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemPresenter.vue?vue&type=style&index=0&id=ed42cffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed42cffe",
  null
  
)

export default component.exports